export class ScrollValues {
  private initialScrollTop: number;
  private initialScrollLeft: number;
  currentScrollTop: number;
  currentScrollLeft: number;
  constructor(initialScrollTop: number, initialScrollLeft: number) {
    this.initialScrollTop = initialScrollTop;
    this.initialScrollLeft = initialScrollLeft;
    this.currentScrollTop = initialScrollTop;
    this.currentScrollLeft = initialScrollLeft;
  }

  get deltaTop() {
    return this.currentScrollTop - this.initialScrollTop;
  }

  get deltaLeft() {
    return this.currentScrollLeft - this.initialScrollLeft;
  }
}
